export function findDuplicates(
  duplicateCases: Array<any> | undefined,
  caseId: any,
): Array<any> | undefined {
  let duplicateCaseList: any = duplicateCases?.filter(
    (duplicatecase: any) => duplicatecase.caseId !== Number(caseId),
  )
  return duplicateCaseList
}
